import { useFormikContext } from "formik";
import { useEffect } from "react";

export default function ApiRender({ handleFetchCall }) {
  const { values, setValues, setFieldValue } = useFormikContext();

  useEffect(() => {
    if (handleFetchCall) handleFetchCall(setValues, values);
  }, []);
}
